import register from '@kpsys/angularjs-register';

import uibDropdownDecorator from './uib-dropdown.decorator';
import logProviderDecorator from './log.decorator';

/**
 * @ngdoc module
 * @name portaro.decorators
 * @module portaro.decorators
 */

export default register('portaro.decorators')
    .config(uibDropdownDecorator)
    .config(logProviderDecorator)
    .name();